<button mat-button [mat-menu-trigger-for]="menu">
  <span [class]="getFlagClass(selectedLocale)"></span>
  @if ((isHandset$ | async) === false) {
    <span>{{ getLocaleLabel(selectedLocale) }}</span>
  }
  <mat-icon>arrow_drop_down</mat-icon>
</button>
<mat-menu #menu="matMenu">
  @for (locale of SUPPORTED_LOCALES; track locale) {
    <a mat-menu-item [attr.href]="'/' + locale" (click)="setLocale(locale, $event)">
      <span [class]="getFlagClass(locale)"></span>{{ getLocaleLabel(locale) }}
    </a>
  }
</mat-menu>
